import { Group, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineUsers } from 'react-icons/hi';
import FacilitatorItem from './FacilitatorItem';
import { PICData } from 'types/lcms/courses';

interface FacilitatorProps {
  dataPIC?: PICData;
  loading?: boolean;
}

const Facilitator: React.FC<FacilitatorProps> = ({ dataPIC, loading = false }) => {
  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineUsers />
          <Text c={'dark'} fw={700}>
            Facilitator
          </Text>
        </Group>
        {loading && (
          <Group>
            {[...Array(3)].map((_, index) => (
              <FacilitatorItem key={index} loading />
            ))}
          </Group>
        )}
        {!loading && dataPIC && (
          <Stack gap={8}>
            <Text c={'dark'} fz={'sm'} fw={700}>
              PIC Approval
            </Text>
            <FacilitatorItem {...dataPIC} />
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default Facilitator;
